import { render, staticRenderFns } from "./NavigationItemBadge.vue?vue&type=template&id=2686fb24&scoped=true&"
import script from "./NavigationItemBadge.vue?vue&type=script&lang=ts&"
export * from "./NavigationItemBadge.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationItemBadge.vue?vue&type=style&index=0&id=2686fb24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686fb24",
  null
  
)

export default component.exports